import { useCallback } from 'react';
import { pick } from 'ramda';

import { getSha256 } from 'js/app/utils/getSha256';
import { useUserSelector } from 'js/store/hooks';

/* eslint-disable camelcase */
export const useGtmEvent = () => {
    const {
        isLoggedIn, userName, paymentsStatistics, userDetails
    } = useUserSelector(pick(['isLoggedIn', 'userName', 'paymentsStatistics', 'userDetails']));

    return useCallback(async (eventName, additionalData = {}) => {
        let userDataToPush = {};

        if (!window.dataLayer) {
            return;
        }

        if (isLoggedIn) {
            userDataToPush = {
                logged_in: true,
                user_sequence: await getSha256(userName),
                user_band: userDetails.vipLevel,
                user_business_phase: userDetails.accountBusinessPhase,
                user_total_deposit_count: parseInt(paymentsStatistics.deposits?.totalDepositCount),
                user_approved_withdraw_requests_count: parseInt(paymentsStatistics.withdrawals?.approvedWithdrawRequestsCount),
                user_pending_withdraw_requests_count: parseInt(paymentsStatistics.withdrawals?.pendingWithdrawRequestsCount),
                user_signup_date: userDetails.signupDate,
                user_wants_marketing_mail: userDetails.wantMail,
                user_allow_bonus: userDetails.noBonus,
                user_home_venue: userDetails.homeVenue
            };
        } else {
            userDataToPush = {
                logged_in: false,
                user_sequence: 'guest'
            };
        }

        window.dataLayer.push(
            { event: eventName, ...userDataToPush, ...additionalData }
        );
    }, [isLoggedIn, userName, paymentsStatistics, userDetails]);
};
